import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import { WebhookConfig } from '../queries';
import { WebhookForm } from './WebhookForm';

interface Props {
  open: boolean;
  agencyId: number;
  webhook?: WebhookConfig;
  onClose: () => void;
}

export const WebhookModal = ({ open, agencyId, webhook, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {webhook ? t('webhooks.modal.editTitle') : t('webhooks.modal.createTitle')}
        <IconButton onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <WebhookForm agencyId={agencyId} webhook={webhook} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
